// for node
const globalWindowObjFallback = {};

/**
 *
 * @param resourceName: name of resource
 * @param fallbackFactory: a fallback value to be assigned as shared resource in case there is no current shared resource
 */

export function getSharedPremiumResource() {
  var _windowObj$PremiumSha;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  const [resourceName, fallbackFactory] = args;
  const isNodeEnv = typeof window === 'undefined';
  const windowObj = isNodeEnv ? globalWindowObjFallback : window;
  let resource = (_windowObj$PremiumSha = windowObj.PremiumSharedApi) == null ? void 0 : _windowObj$PremiumSha[resourceName];
  if (!resource && fallbackFactory) {
    resource = fallbackFactory();
    setSharedPremiumResource(resourceName, resource);
  }
  return resource;
}
export const setSharedPremiumResource = (resourceName, value) => {
  const isNodeEnv = typeof window === 'undefined';
  const windowObj = isNodeEnv ? globalWindowObjFallback : window;
  if (!windowObj.PremiumSharedApi) {
    windowObj.PremiumSharedApi = {};
  }
  const prevValue = windowObj.PremiumSharedApi[resourceName];
  windowObj.PremiumSharedApi[resourceName] = value;
  return prevValue;
};
//# sourceMappingURL=getSharedPremiumResource.js.map